<template>
    <v-dialog v-if="isLeserserviceOrHigher" class="ad-hoc-purchase" v-model="showDialog" max-width="500" persistent>
        <template v-slot:activator="{ on }">
            <div v-on="on" class="ad-hoc-purchase__activator">
                <v-tooltip left v-if="!alternativeBtn">
                    <template #activator="{ on }">
                        <v-btn v-bind="$attrs" text icon color="primary" v-on="on">
                            <v-icon v-bind="$attrs">mdi-human</v-icon>
                        </v-btn>
                    </template>
                    <span>Sofortfreischaltung</span>
                </v-tooltip>
                <v-tooltip bottom v-if="alternativeBtn">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" v-bind="$attrs" class="drei_60-btn mb-2" block>Sofortfreischaltung</v-btn>
                    </template>
                    <div class="max-width-btn">
                        Einrichten zeitlich begrenzter Nutzungsrechte für alle Publisher und Produkte. Die SAP-Daten werden dadurch nicht aktualisiert.
                    </div>
                </v-tooltip>
            </div>
        </template>
        <v-card>
            <v-card-title class="title">Sofortfreischaltung</v-card-title>
            <v-card-text>
                <p class="body-2" v-if="stores.length > 0">
                    Für welchen Publisher soll die Sofortfreischaltung erfolgen?
                </p>
                <v-item-group>
                    <v-item
                        v-for="(store, index) in stores"
                        :key="index">
                        <v-chip
                            outlined
                            class="ma-2"
                            :color="store !== selectedStore ? 'primary' : 'success'"
                            @click="loadOffers(store)"
                        >{{ store }}</v-chip>
                    </v-item>
                </v-item-group>
                <v-container
                    d-flex
                    align-center
                    justify-center
                    v-if="showProgressSpinner"
                >
                    <v-progress-circular
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                </v-container>
                <v-alert
                        :value="hasError"
                        color="error"
                        icon="mdi-alert-circle"
                        outlined
                >
                    {{ errorMessage }}
                </v-alert>
                <v-form v-model="formValid" v-if="offers.length > 0">
                    <v-combobox
                        no-filter
                        :items="offers"
                        item-text="name"
                        item-value="offerId"
                        label="Produkt"
                        :rules="comboboxRules"
                        :value="selectedOffer"
                        @change="setSelectedOffer"
                    ></v-combobox>
                    <v-layout wrap>
                        <v-flex xs12 sm6 md6 pr-2>
                            <v-menu
                                    v-model="menuValidFrom"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            :value="validFromFormatted"
                                            :rules="validFromRules"
                                            label="Von"
                                            prepend-icon="mdi-calendar"
                                            :readonly="!menuValidFrom"
                                            :hide-details="false"
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    :value="validFrom"
                                    first-day-of-week="1"
                                    locale="de-DE"
                                    :min="today"
                                    :max="validTo ? validTo : undefined"
                                    @input="changeValidFrom"
                                ></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 sm6 md6 pl-2>
                            <v-menu
                                    v-model="menuValidTo"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            :value="validToFormatted"
                                            :rules="validToRules"
                                            label="Bis"
                                            prepend-icon="mdi-calendar"
                                            :readonly="!menuValidTo"
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    :value="validTo"
                                    locale="de-DE"
                                    first-day-of-week="1"
                                    :min="validFrom"
                                    @input="changeValidTo"
                                ></v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="warning"
                    outlined
                    @click="abbort"
                    :disabled="loading"
                >Abbrechen</v-btn>
                <v-btn
                    color="success"
                    outlined
                    :loading="loading && processing"
                    :disabled="loading || !formValid"
                    @click="savePurchase"
                >
                    Speichern
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {
    mapActions,
    mapMutations,
    mapState,
    mapGetters,
} from 'vuex';

export default {
    name: 'AdHocPurchase',
    props: {
        ssoId: String,
        alternativeBtn: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showDialog: false,
            formValid: false,
            processing: false,
            menuValidFrom: false,
            menuValidTo: false,
            today: new Date().toISOString().substr(0, 10),
            comboboxRules: [
                v => !!v || 'Produkt muss ausgewählt sein.',
            ],
            validFromRules: [
                v => !!v || 'Von muss gesetzt sein.',
                () => new Date(this.validFrom).getTime() >= new Date(this.today).getTime() || 'Von muss größer gleich heute sein.',
                v => (!this.validTo || new Date(v).getTime() <= new Date(this.validTo).getTime()) || 'Von muss kleiner gleich Bis sein.',
            ],
            validToRules: [
                v => !!v || 'Bis muss gesetzt sein.',
                () => new Date(this.validTo).getTime() >= new Date(this.validFrom) || 'Bis muss größer gleich Von sein.',
            ],
        };
    },
    computed: {
        ...mapState('adHocPurchase', [
            'loading',
            'stores',
            'errorMessage',
            'selectedStore',
            'selectedOffer',
            'validFrom',
            'validFromFormatted',
            'validTo',
            'validToFormatted',
        ]),
        ...mapGetters('adHocPurchase', [
            'offers',
            'hasError',
        ]),
        ...mapGetters(['isLeserserviceOrHigher']),
        showProgressSpinner() {
            return (this.offers.length <= 0 && this.loading && !!this.selectedStore)
                || (this.loading && this.stores.length <= 0);
        },
    },
    methods: {
        ...mapActions('adHocPurchase', ['loadStores', 'loadOffers', 'commitPurchase']),
        ...mapMutations('adHocPurchase', [
            'setSelectedOffer',
            'setValidFrom',
            'setValidTo',
            'resetState',
        ]),
        ...mapMutations('snackbar', ['error', 'success', 'info']),
        savePurchase() {
            this.processing = true;
            this.commitPurchase(this.ssoId)
                .then((message) => {
                    this.success(message);
                    this.showDialog = false;
                    this.$emit('close');
                })
                .catch(({ message }) => {
                    this.processing = false;
                    this.error(message);
                });
        },
        abbort() {
            this.info('Das Erstellen einer Sofortfreigabe wurde abgebrochen.');
            this.resetState();
            this.processing = false;
            this.showDialog = false;
            this.$emit('close');
        },
        changeValidFrom(value) {
            this.setValidFrom(value);
            this.menuValidFrom = false;
        },
        changeValidTo(value) {
            this.setValidTo(value);
            this.menuValidTo = false;
        },
    },
    watch: {
        showDialog(value) {
            if (value) {
                this.loadStores();
            } else {
                this.resetState();
                this.formValid = false;
                this.processing = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
    .ad-hoc-purchase__activator {
        width: 100%;
    }
</style>
